/**
 * "Add to calendar": a one-event .ics file the phone opens in its calendar app. Times are written
 * as floating local times (no time zone), which is what members expect for a church lift.
 */
export interface CalendarEvent {
  title: string;
  start: Date;
  /** Length in minutes (default 60). */
  minutes?: number;
  location?: string;
  description?: string;
  /** Stable id so adding twice updates the same entry. */
  uid: string;
}

const pad = (n: number) => String(n).padStart(2, '0');
const stamp = (d: Date) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
const esc = (s: string) => s.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');

export function calendarFile(e: CalendarEvent): string {
  const end = new Date(e.start.getTime() + (e.minutes ?? 60) * 60_000);
  const now = new Date();
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Acts Church//Carpool//EN',
    'BEGIN:VEVENT',
    `UID:${e.uid}@carpool.actschurch.co.za`,
    `DTSTAMP:${stamp(now)}`,
    `DTSTART:${stamp(e.start)}`,
    `DTEND:${stamp(end)}`,
    `SUMMARY:${esc(e.title)}`,
    e.location ? `LOCATION:${esc(e.location)}` : '',
    e.description ? `DESCRIPTION:${esc(e.description)}` : '',
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean).join('\r\n');
}

/** Download the .ics file (phones offer "Add to calendar"). */
export function downloadCalendarFile(e: CalendarEvent, fileName = 'carpool-lift.ics'): void {
  try {
    const blob = new Blob([calendarFile(e)], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
  } catch {
    // Old browsers without Blob downloads: nothing to do, the details stay on screen.
  }
}
